export default [
  {
    name: 'Wirtschaft',
    description:
      'Die Wirtschaftswissenschaften in ihrer ganzen Vielfalt an Ansätzen und Strömungen sind meine Leidenschaft, die sich seit der Oberschule, als ich an der Olympiade teilnahm, entwickelt hat. Die Neugier, wie ein Staat geführt werden kann, wurde zur Inspiration für die Schaffung meiner Plattform für politische Tests, Soulgraphy.',
    image: 'kanada',
  },
  {
    name: 'Natur und Tierwelt',
    description:
      'Von klein auf fasziniert mich die Tierwelt und die Umwelt, in der sie leben. Als Kind wollte ich Zoologe werden.',
    image: 'seal',
  },
  {
    name: 'Länder der Welt',
    description:
      'Mit jedem Jahr fasziniert es mich mehr, mein Wissen über verschiedene Ecken der Welt zu vertiefen. Wie sich Sprachen im Laufe der Zeit entwickelt haben, hilft, die Kultur und Denkweise der Menschen aus verschiedenen Ländern besser zu verstehen. Wenn man in ihre Geschichte eintaucht, fällt es leichter zu erkennen, was ihre Gegenwart prägt. Besonders interessieren mich die nordischen Länder und Japan.',
    image: 'japan',
  },
  {
    name: 'Elektronische Technologien',
    description:
      'Elektronik, Programmierung oder Telekommunikationstechnologien sind für mich nicht nur ein interessantes Wissenschaftsgebiet. Sie sind vor allem ein Werkzeug, durch das ich mich wie ein Erfinder fühlen und selbstständig eigene elektronische Schaltungen oder Webanwendungen entwickeln kann.',
    image: 'telecommunications',
  },
  {
    name: 'Physik und Technologie',
    description:
      'Ich war schon immer neugierig, wie die Welt funktioniert. Egal, ob es um den Strom in einer Glühbirne geht oder darum, warum die Sonne scheint. Physik ist für mich der Prozess, die Welt kennenzulernen und zu verstehen, warum sie sich so verhält und nicht anders. Die Nutzung dieses Wissens gibt brillanten Köpfen die Werkzeuge, um innovative Lösungen zu schaffen, die die Welt vor unseren Augen verändern – von billiger und sauberer Energie über leistungsstarke Batterien bis hin zu lebensrettenden Medikamenten.',
    image: 'physics',
  },
  {
    name: 'Kochen',
    description:
      'Ich liebe es zu kochen und in der Küche zu experimentieren, und die Zubereitung von Nudeln oder Fleisch ist ein fester Bestandteil meines Tages. Neben der polnischen Küche liebe ich koreanische und indische Gerichte.',
    image: 'cooking',
  },
  {
    name: 'Fantasy, Spiele und Entspannung',
    description:
      'Niemand bei klarem Verstand kommt von der Arbeit zurück zu einem weiteren Job, denn jeder braucht Entspannung und Zeit, um vom Alltag abzuschalten. Wenn ich das tue, schaue ich normalerweise Filme, erkunde (und schreibe) Fantasy, mache Roadtrips oder spiele mit Freunden die verschiedensten Spiele.',
    image: 'relax',
  },
]
